import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import {
	LANDING_DOWNLOAD_TRIGGER_OPTIONS,
	type LandingDownloadTrigger,
} from '@/entities/landing.entity';

interface DownloadTriggerSelectProps {
	value: LandingDownloadTrigger;
	onValueChange: (value: LandingDownloadTrigger) => void;
	disabled?: boolean;
}

export default function DownloadTriggerSelect({
	value,
	onValueChange,
	disabled,
}: DownloadTriggerSelectProps) {
	return (
		<div className='flex flex-col gap-1.5'>
			<Label>Режим скачивания APK</Label>
			<Select
				value={value}
				onValueChange={next => onValueChange(next as LandingDownloadTrigger)}
				disabled={disabled}
			>
				<SelectTrigger>
					<SelectValue placeholder='Выберите режим' />
				</SelectTrigger>
				<SelectContent>
					{LANDING_DOWNLOAD_TRIGGER_OPTIONS.map(option => (
						<SelectItem key={option.value} value={option.value}>
							{option.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
}
